module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAgCAYAAAASYli2AAAAxUlEQVR4Ae2VwQ3CMAwAO0IG4NEX74zQUTpCR8gGjMAIHSEjMEJGyAghjwMiFGxoeNrSPULMWbYrZXqPdD75Sq4UhXWSApmrJFEEFPWaMJJ8q7jDeSSFbyvTSSZ/7yUs+my6sy6wfap27fxxpqDv3G2N1KvzaMZQhII7d4kfXhWElmI7EuHLWJ5CoZ3I+cI5CFsXhUuz9ZWRsIDfhSQiAeRuROhYTKTlmatDQj1MaEI5TGhCE0IYILXCzOEf+MfrFobhvb4DsOD8fBT43GcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/key-tag-icon.png
// module id = 480
// module chunks = 0